import _ from 'underscore';

import {assertAndContinue} from 'Asserts';
import {Status} from 'constants/StatusConstants';
import {ComputedSchemaTag, isSchemaTag, SchemaTag, UnaffiliatedSchemaTag} from 'folder-items/FileConstants';
import {Optional} from 'util/Types';

export const COMPUTING_STATUS_TEXT = 'Computing...';

export function isComputedTag(tag: SchemaTag | UnaffiliatedSchemaTag): tag is ComputedSchemaTag {
  return isSchemaTag(tag) && tag.tagSchemaField.isComputed;
}

export function shouldShowComputedState(tag: SchemaTag | UnaffiliatedSchemaTag): tag is ComputedSchemaTag {
  if (!isComputedTag(tag)) {
    return false;
  }
  if (tag.computedState == null) {
    assertAndContinue(false, 'Expected computedState on tag for computed field.', {tag});
    return false;
  }

  return tag.computedState.status !== Status.SUCCEEDED;
}

export function computedStateExtraText(tag: SchemaTag): Optional<string> {
  if (tag.computedState == null) {
    assertAndContinue(false, 'Expected computedState on tag for computed field.', {tag});
    return null;
  }

  if (tag.computedState.status === Status.FAILED) {
    return tag.computedState.errorMessage;
  } else if ([Status.PENDING, Status.RUNNING].includes(tag.computedState.status)) {
    return COMPUTING_STATUS_TEXT;
  } else {
    return tag.value;
  }
}

export function hasComputedTags(tags: Array<SchemaTag>): boolean {
  return _.any(tags, (tag) => isComputedTag(tag));
}
